import styled from 'styled-components'

const Loading = () => {
  return (
    <Wrapper>
      <span>Loading...</span>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  font-size: 13px;
`

export default Loading
